const $intlTelInputs = $('[data-toggle="intl-tel-input"]');

$intlTelInputs.each((index, element) => {
    $(element).intlTelInput({
        utilsScript: 'https://www.juwaistatic.com/frontend-libraries/intl-tel-input/9.2.4/js/utils.js',
        preferredCountries: ['cn', 'us', 'au'],
        initialCountry: 'auto',
        geoIpLookup: (success) => {
            $.getJSON('https://www.juwai.com/location/?callback=?').always((data) => {
                const countryCode = (data && data.country_code) ? data.country_code : 'cn';

                success(countryCode);
            });
        },
    });
});



// WEBPACK FOOTER //
// ./src/js/objects/ui-o-form.js